/* ServiceAddon.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const Requestolizer = require("./Requestolizer");
const ConnectionHandlerFactory = require("@gluenetworks/platform-sdk-remote").connectionFactories
    .ConnectionHandlerFactory;

class ServiceAddon extends EventEmitter {
    constructor(logger, di, router) {
        super();
        this._logger = logger;
        this._di = di;
        this._router = router;
    }

    //BEGIN PUBLIC API
    initialize(/*steve,addOnOptions*/) {
        return Promise.resolve();
    }

    startUp(/*steve,addOnOptions*/) {
        let systemUri = this._router.protocol + "//" + this._router.hostname;
        let port = this._router.port;
        let path = "/ControlApi/socket.io";

        this._connection = ConnectionHandlerFactory.getInstance("socket", systemUri, port, {
            path: path,
        });

        return this._connection.connect().then(() => {
            return new Promise((resolve, reject) => {
                this._connection._socket.emit("api", (response) => {
                    if (response) {
                        this._buildApi(response);
                        resolve(response);
                    } else {
                        reject(response);
                    }
                });
            });
        });
    }

    shutdown() {}

    // END PUBLIC API
    // BEGIN PRIVATE METHODS

    _buildApi(apiObj) {
        Object.keys(apiObj).forEach((apiName) => {
            let shortName = apiName.replace(/Service/, "");
            let service = new Requestolizer(this._connection._socket, apiObj[apiName], apiName);

            //This is what the DI system will use for dependency injection.
            this._di.registry.register("$teve.services." + shortName, service);
        });
    }
}

module.exports = ServiceAddon;
module.exports.$inject = ["$teve.logger", "$teve.di", "$teve.router"];
